import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentIdentityService } from '../services/current-identity.service';

/**
 * Role-based access control guard
 * Checks if current user has permission to access route based on role
 */
export const roleGuard: CanActivateFn = (route) => {
  const identityService = inject(CurrentIdentityService);
  const router = inject(Router);

  // Get required permission from route data
  const requiredPermission = route.data['permission'] as string;

  if (!requiredPermission) {
    // No permission required, allow access
    return true;
  }

  // If user is not loaded yet, allow navigation and let component handle loading
  if (!identityService.currentUser()) {
    return true;
  }

  // Check permission using IdentityService methods
  let hasPermission = false;

  switch (requiredPermission) {
    case 'dashboard':
      hasPermission = identityService.canViewDashboard();
      break;
    case 'reports':
      hasPermission = identityService.canViewReports();
      break;
    case 'projects':
      hasPermission = identityService.canViewProjects();
      break;
    case 'qualityGates':
      hasPermission = identityService.canViewQualityGates();
      break;
    case 'users':
      hasPermission = identityService.canViewUsers();
      break;
    case 'teams':
      hasPermission = identityService.canViewTeams();
      break;
    case 'teamSettings':
      hasPermission = identityService.canViewTeamSettings();
      break;
    default:
      hasPermission = false;
  }

  if (!hasPermission) {
    // Redirect to dashboard if no permission
    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};
